(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kc-product-sizes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kc-size-links')) {
  customElements.define('kc-size-links', class extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('[data-size-url]')].map(link => ({link, variants: JSON.parse(link.querySelector('[data-size-variants]').textContent)}));
      const details = this.closest('.kc-purchase-details');
      const update = () => {
        const selected = details?.querySelector('[data-kc-option][data-option-index="' + this.dataset.colorIndex + '"][aria-checked="true"]');
        const color = selected?.dataset.optionValue || this.dataset.currentColor;
        for (const {link, variants} of this.links) {
          const variant = variants.find(item => item.color.toLocaleLowerCase('tr-TR') === color.toLocaleLowerCase('tr-TR'));
          const url = new URL(link.dataset.sizeUrl, location.origin);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.set('kc_color_unavailable', '1');
          link.href = url.pathname + url.search;
        }
      };
      update();
      this.observer = new MutationObserver(update);
      if (details) this.observer.observe(details, {subtree: true, attributes: true, attributeFilter: ['aria-checked']});
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kc-return-policy"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('kc-return-policy');
  if (!dialog) return;
  let trigger, previousOverflow;
  const policyBody = dialog.querySelector('.kc-return-sheet__body');
  const keepPolicyScroll = event => {
    if (dialog.open) event.stopPropagation();
  };
  policyBody.addEventListener('touchmove', keepPolicyScroll, {passive:true});
  policyBody.addEventListener('wheel', keepPolicyScroll, {passive:true});
  policyBody.addEventListener('keydown', event => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) keepPolicyScroll(event);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-kc-return-open]');
    if (!link || !dialog.showModal) return;
    event.preventDefault();
    if (dialog.open) return;
    trigger = link;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('.kc-return-sheet__body').scrollTop = 0;
  });
  dialog.querySelector('[data-kc-return-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (trigger && trigger.isConnected) trigger.focus({preventScroll:true});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kc-review-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kc-review-colors')) {
    customElements.define('kc-review-colors', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (!this.section || this.observer) return;
        try { this.catalog = JSON.parse(this.querySelector('script').textContent); } catch (_) { return; }
        this.choices = new Map();
        this.offsets = new Map();
        this.frame = null;
        this.observer = new MutationObserver(() => {
          if (this.frame !== null) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.applyColors(); });
        });
        this.observer.observe(this.section, {childList:true, subtree:true, attributes:true, attributeFilter:['src','data-src','data-src-retina']});
        this.applyColors();
      }
      imageKey(value) {
        try { return new URL(value, location.origin).pathname.split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/, ''); } catch (_) { return ''; }
      }
      applyColors() {
        this.section.querySelectorAll('.jdgm-carousel-item__product-image').forEach(img => {
          const card = img.closest('[data-review-id]');
          if (!card) return;
          const id = card.getAttribute('data-review-id');
          let choice = this.choices.get(id);
          if (!choice) {
            const source = img.getAttribute('data-src') || img.getAttribute('src');
            const product = this.catalog.find(p => p.title === img.alt && this.imageKey(p.original) === this.imageKey(source));
            if (!product) return;
            const images = product.images.filter((v,i,a) => a.findIndex(x => x.url === v.url) === i);
            if (images.length < 2) return;
            const index = this.offsets.has(product.title) ? this.offsets.get(product.title) : 1 + Math.floor(Math.random() * (images.length - 1));
            choice = {...images[index % images.length], title:product.title};
            this.offsets.set(product.title, index + 1);
            this.choices.set(id, choice);
          }
          img.loading = 'lazy';
          for (const attr of ['src','data-src','data-src-retina']) {
            if (img.getAttribute(attr) !== choice.url) img.setAttribute(attr, choice.url);
          }
          img.alt = choice.title + ' — ' + choice.label;
        });
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.observer = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kc-visible-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kc-search'))customElements.define('kc-search',class extends HTMLElement{
 connectedCallback(){
  this.input=this.querySelector('input[type=search]');this.results=this.querySelector('.kc-search-results');this.abort=new AbortController();
  const options={signal:this.abort.signal};
  this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.request?.abort();this.close();const q=this.input.value.trim();if(q.length>1)this.timer=setTimeout(()=>this.search(q),220)},options);
  this.input.addEventListener('focus',()=>{if(this.results.textContent.trim()&&this.last===this.input.value.trim())this.open()},options);
  this.addEventListener('keydown',e=>{const links=[...this.results.querySelectorAll('a')];if(e.key==='Escape'){this.close();this.input.focus()}if(!this.results.hidden&&(e.key==='ArrowDown'||e.key==='ArrowUp')){e.preventDefault();const i=links.indexOf(document.activeElement),next=e.key==='ArrowDown'?i+1:i-1;links[(next+links.length)%links.length]?.focus()}},options);
  this.addEventListener('focusout',()=>setTimeout(()=>{if(!this.contains(document.activeElement))this.close()},0),options);
  document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))this.close()},options);
 }
 disconnectedCallback(){this.abort?.abort();this.request?.abort();clearTimeout(this.timer)}
 close(){this.results.hidden=true;this.input.setAttribute('aria-expanded','false')}
 open(){this.results.hidden=false;this.input.setAttribute('aria-expanded','true')}
 async search(q){this.request=new AbortController();try{const url=new URL(this.dataset.endpoint,location.origin);url.search=new URLSearchParams({q,'resources[type]':'product','resources[limit]':'5',section_id:'kc-predictive-search'});const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw new Error();const html=await response.text();if(this.input.value.trim()!==q)return;const doc=new DOMParser().parseFromString(html,'text/html'),content=doc.querySelector('[data-kc-search-content]');if(content){this.results.replaceChildren(...content.childNodes);this.last=q;if(this.contains(document.activeElement))this.open()}}catch(e){if(e.name!=='AbortError')this.close()}}
});
  } catch(e) { console.error(e); }
})();

})();
